import ClassNameExtendableHoC from 'components/HoC/ClassNameExtendableHoC';

const Title = ClassNameExtendableHoC('h4', 'ds-title');
const SubTitle = ClassNameExtendableHoC('p', 'ds-title__sub');

export {
  Title,
  SubTitle,
};
